import type { OtpUiTexts } from "@codway-dev/shared";
import type { CallbackEvent } from "@shopify/polaris-types";
import { useOtpConfigStore } from "../../store/useOtpConfigStore";

const UI_TEXT_FIELDS: Array<{
  key: keyof OtpUiTexts;
  label: string;
  helpText?: string;
  multiline?: boolean;
}> = [
  { key: "title", label: "Título" },
  {
    key: "description",
    label: "Descripción",
    helpText:
      "Use {phone_number} para insertar dinámicamente el número de teléfono del cliente en este campo de texto.",
    multiline: true,
  },
  { key: "verify_button", label: "Texto del botón Comprobar" },
  { key: "resend_button", label: "Texto del botón Reenviar código" },
  {
    key: "change_phone_button",
    label: "Texto del botón Cambiar número de teléfono",
  },
  { key: "hint_text", label: "Texto de sugerencia Código no recibido" },
  {
    key: "new_code_sent_text",
    label: "Texto Nuevo código enviado",
    helpText:
      "Use {phone_number} para insertar dinámicamente el número de teléfono del cliente en este campo de texto.",
  },
  { key: "invalid_code_error", label: "Texto de error Código OTP no válido" },
  {
    key: "resends_limit_error",
    label: "Texto de error Límite de reenvío excedido",
  },
  { key: "contact_support_button", label: "Texto del botón Contactar soporte" },
  {
    key: "support_message_template",
    label: "Mensaje pre-llenado de soporte",
    multiline: true,
  },
];

const PHONE_PLACEHOLDER_KEYS: Array<keyof OtpUiTexts> = [
  "description",
  "new_code_sent_text",
];

export function OtpUiTextsEditor() {
  const uiTexts = useOtpConfigStore((s) => s.uiTexts);
  const updateUiText = useOtpConfigStore((s) => s.updateUiText);

  return (
    <s-stack direction="block" gap="base">
      {UI_TEXT_FIELDS.map(({ key, label, helpText, multiline }) => {
        const missingPhonePlaceholder =
          PHONE_PLACEHOLDER_KEYS.includes(key) &&
          !uiTexts[key].includes("{phone_number}");

        return multiline ? (
          <s-stack key={key} direction="block" gap="small-100">
            <s-text-area
              label={label}
              value={uiTexts[key]}
              onInput={(e: CallbackEvent<"s-text-area">) =>
                updateUiText(key, e.currentTarget.value)
              }
            />
            {helpText && <s-text color="subdued">{helpText}</s-text>}
            {missingPhonePlaceholder && (
              <s-text tone="critical">
                Falta el marcador {"{phone_number}"} — sin él, el texto no
                mostrará el número de teléfono del cliente.
              </s-text>
            )}
          </s-stack>
        ) : (
          <s-stack key={key} direction="block" gap="small-100">
            <s-text-field
              label={label}
              value={uiTexts[key]}
              onInput={(e: CallbackEvent<"s-text-field">) =>
                updateUiText(key, e.currentTarget.value)
              }
            />
            {helpText && <s-text color="subdued">{helpText}</s-text>}
            {missingPhonePlaceholder && (
              <s-text tone="critical">
                Falta el marcador {"{phone_number}"} — sin él, el texto no
                mostrará el número de teléfono del cliente.
              </s-text>
            )}
          </s-stack>
        );
      })}
    </s-stack>
  );
}
